import React from 'react'
import styled from 'styled-components'

import bookImage from '../../images/book-v3.png'

const StyledImage = styled.img`
  display: block;
  height: auto;
  max-width: 430px;
  width: 100%;
`

const BookImage = () => (
  <StyledImage src={bookImage} alt="Shenanigans book cover" loading="lazy" />
)

export default BookImage
